import type {TaskOption} from '../types/types';

export const getBreadcrumbWithoutLeaf = (task: TaskOption) => {
	// Strip the task name from the full breadcrumb to avoid splitting on "/" which can be part of the name.
	const {breadCrumbs, name} = task;
	return breadCrumbs.substring(0, breadCrumbs.length - name.length).replace(/\/$/, '');
};
